<template>
  <div class="creditForm">
    <div class="creditForm__label">カード番号</div>
    <div class="creditForm__ccNumberWrap">
      <div class="creditForm__ccNumber">{{ ccNumber }}</div>
      <a class="creditForm__change" @click.prevent="$emit('new-credit')">変更</a>
    </div>

    <form-select
      name="number_payments"
      label="支払い回数"
      :value="input.numberPayments"
      @input="changeInput($event, 'numberPayments')"
      :options="option.numberPayments"
      :validation="{ rules: { required: true,} }"
    ></form-select>

    <div class="creditForm__notice">
      <p>※分割払いは、JCB／AMEXのみご利用いただけます。その他ブランドのクレジットカードをご利用のお客様は、一括払いかコンビニ決済でお支払いください。</p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'CreditCardFormSplitRegisterd',
  props: {
    input: Object,
    option: Object,
    card: Object,
  },
  data() {
    return {
      ccNumber: this.separation(this.card.number)
    }
  },
  methods: {
    // クレジットカード番号に区切りを入れる
    separation(value) {
      switch (this.card.brandCode) {
        case 'J':
        case 'V':
        case 'M':
        case 'X':
          return value.replace(/(.{4})(.{4})(.{4})/, '$1 $2 $3 ')
          break
        case 'A':
          return value.replace(/(.{6})(.{5})$/, ' $1 $2')
          break
        case 'D':
          return value.replace(/(.{6})(.{4})$/, ' $1 $2')
          break
      }
    },
    // 親に変更を送る
    changeInput($event, target) {
      this.$emit('change', { target: target, value: $event })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../../../sass/commons/commonVariables.scss';
.creditForm {
  margin: 0 0 24px;
  &__label {
    font-weight: bold;
    font-size: 13px;
    line-height: 15px;
    color: $academy_purple;
    margin: 0 0 8px;
  }
  &__ccNumberWrap {
    position: relative;
    border: 1px solid $academy_purple;
    box-sizing: border-box;
    border-radius: 5px;
    margin: 0 0 22px;
    padding: 9px 14px 7px;
  }
  &__ccNumber {}
  &__change {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 16px;
    height: 1em;
    margin: auto;
    font-size: 13px;
    line-height: 1;
    font-weight: 500;
    text-decoration: underline;
    cursor: pointer;
  }
  &__notice {
    font-size: 12px;
    margin: -12px 0 24px;
    color: $academy_purple;
    line-height: 1.2;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Academy/partials/CreditCardFormSplitRegistered.vue